import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface Props {
  inBody: boolean;
  child: HTMLElement;
  excludeUrls?: string[];
}

export const useLoadScript = ({ inBody, child, excludeUrls }: Props) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!excludeUrls?.find((url) => pathname.includes(url))) {
      if (inBody) {
        document.body.appendChild(child);
      } else {
        document.head.appendChild(child);
      }
    }
  }, []);
};
